import React, { Component } from 'react';
import BaseLayout from './../../templates/base'
import Form from './../../elements/notifications/form';
import Loading from "../../elements/loading";
import NotificationAdd from './../../elements/notifications/widget/notification_type_add';

class NotificationTypeForm extends Component {
	render() {
		const { notifications_types, status } = this.props;
		return (
			(notifications_types.isFetching || status.isFetching ) ? <Loading/>:<Form {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.reset('notifications_types.edit');
		this.props.notificationTypeEdit(this.props.match.params.id);
		this.props.fetchGroupsPhasesList();
		this.props.fetchStatus(1);
	}
}

export default BaseLayout(NotificationTypeForm, {
	title:`Editar notificatión`,
	subnav: {
		icon: 'fa fa-calendar-check-o',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <NotificationAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/notifications/edit.jsx